import React from "react";
import type {
  DifyAPITestRunStatus,
  QuestionTableList,
} from "~/components/difyAPITest/difyAPITest.types";

/**
 * 実行状態ごとの表示定義
 */
const runStatusMetaMap: Record<
  DifyAPITestRunStatus,
  {
    label: string;
    className: string;
  }
> = {
  running: { label: "実行中", className: "dify-history-status-running" },
  completed: { label: "完了", className: "dify-history-status-completed" },
  error: { label: "エラーあり", className: "dify-history-status-error" },
  cancelled: { label: "キャンセル", className: "dify-history-status-cancelled" },
};

/**
 * 長い文字列を一覧表示用に短縮する
 * @param value 表示対象の文字列
 * @param maxLength 最大文字数
 * @return 短縮後の文字列
 */
const toPreviewText = (value: string, maxLength = 60) => {
  if (!value) {
    return "-";
  }

  if (value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, maxLength)}...`;
};

type DifyRunHistorySectionProps = {
  questionTableList: QuestionTableList[];
  onDownloadRunCsv: (runId: string) => void;
};

/**
 * 実行履歴一覧を表示する
 * @return 画面要素
 */
const DifyRunHistorySection: React.FC<DifyRunHistorySectionProps> = ({
  questionTableList,
  onDownloadRunCsv,
}) => {
  return (
    <div className="dify-history-section">
      <h2 className="dify-history-title">送信した質問一覧</h2>
      <div className="dify-history-table-wrapper">
        <table className="dify-history-table question-submitted">
          <thead>
            <tr>
              <th>質問内容</th>
              <th>送信時刻</th>
              <th>状態</th>
              <th>出力</th>
            </tr>
          </thead>
          <tbody>
            {questionTableList.length === 0 ? (
              <tr>
                <td colSpan={4}>まだ実行履歴がありません。</td>
              </tr>
            ) : (
              questionTableList.map((item) => (
                <tr key={item.runId}>
                  <td>
                    <div>{toPreviewText(item.title)}</div>
                    <div>
                      {item.completedCount}/{item.totalCount} 件完了
                      {item.errorCount > 0 ? ` / エラー ${item.errorCount} 件` : ""}
                    </div>
                  </td>
                  <td>
                    <div>{item.createdAtLabel}</div>
                  </td>
                  <td className={`dify-history-status ${runStatusMetaMap[item.status].className}`}>
                    {runStatusMetaMap[item.status].label}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="button-1 dify-api-custom-button"
                      onClick={() => onDownloadRunCsv(item.runId)}
                      disabled={item.csvData.length === 0}
                    >
                      CSV出力
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DifyRunHistorySection;
